import { useState } from "react";
import { X } from "react-feather";
import { Rating } from "react-simple-star-rating";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Media, Row } from "reactstrap";
import { Href } from "../../../../constants";
import { OrderCardsList } from "../../../../data/applications/ECommerce";
import { OrderHistory } from "../../../../types/Ecommerce";
import { dynamicImage } from "../../../../utils";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { Image } from "../../../../coreComponents/Image";

// This component displays a list of order history cards with options to delete an order.
const OrdersCard: React.FC<OrderHistory> = ({ btn, color, title }) => {

  const [newOrder, setNewOrder] = useState(OrderCardsList);
  const deleteHandler = (id: number) => {
    const newData = newOrder.filter((item) => item.id !== id);
    setNewOrder([...newData]);
  };

  return (
    <Card>
      <CommonCardHeader title={title} />
      <CardBody>
        <Row className="g-sm-4 g-3">
          {/* Mapping through newOrder to display order details */}
          {newOrder.map((item, index) => (
            <Col xxl="4" md="6" key={index}>
              <div className="prooduct-details-box">
                <Media className="d-flex">
                  <Image className="align-self-center img-fluid img-60" src={dynamicImage(`ecommerce/${item.image}`)} alt={item.name} />
                  <Media body className="ms-3 flex-grow-1">
                    <div className="product-name">
                      <h6><Link to={Href}>{item.name}</Link></h6>
                    </div>
                    <Rating initialValue={5} size={17} className="mt-1" />
                    <div className="price d-flex p-0 border-0">
                      <div className="text-muted me-2">Price &nbsp;</div> : 210$
                    </div>
                    <div>
                      <div className="text-success">In stock</div>
                    </div>
                    <Button tag="a" color={color} size="xs" href={Href}>{btn}</Button>
                    <X className="close" onClick={() => deleteHandler(item.id)} />
                  </Media>
                </Media>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default OrdersCard;